import { render } from "./ExtinctSpecies.vue?vue&type=template&id=60875062&scoped=true"
import script from "./ExtinctSpecies.vue?vue&type=script&lang=js"
export * from "./ExtinctSpecies.vue?vue&type=script&lang=js"

import "./ExtinctSpecies.vue?vue&type=style&index=0&id=60875062&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60875062"]])

export default __exports__